var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.item.name))]),_c('table',[_c('tbody',[_c('td',[_vm._v(_vm._s(_vm.item.type))]),_c('td')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }